/* SABR — Barre d'ajout au panier collante (mobile)
   Relaie le clic vers le formulaire produit natif de Dawn afin de conserver
   la variante sélectionnée, la gestion du stock et le panier ajax. */
(function () {
  class SabrStickyAtc extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.sabr-sticky-atc');
      this.trigger = this.querySelector('[data-sabr-sticky-button]');
      this.mainButton = document.querySelector('[id^="ProductSubmitButton-"]');

      if (!this.bar || !this.trigger || !this.mainButton) return;

      this.trigger.addEventListener('click', () => {
        this.mainButton.click();
      });

      this.syncState();

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.bar.classList.toggle('is-visible', !entry.isIntersecting);
            });
          },
          { rootMargin: '0px 0px -80px 0px' }
        );
        this.observer.observe(this.mainButton);
      }

      document.addEventListener('change', () => this.syncState());
      document.addEventListener('variant:change', () => this.syncState());
    }

    syncState() {
      if (!this.mainButton || !this.trigger) return;
      this.trigger.disabled = this.mainButton.disabled;
      const priceEl = document.querySelector('.price__container .price-item--regular');
      const target = this.querySelector('[data-sabr-sticky-price]');
      if (priceEl && target) target.textContent = priceEl.textContent.trim();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('sabr-sticky-atc')) {
    customElements.define('sabr-sticky-atc', SabrStickyAtc);
  }
})();
